import styled, { css, th } from '@xstyled/styled-components'

const ignoredProps = ['internalId', 'inline']

const DropdownItem = styled.buttonBox.withConfig({
  shouldForwardProp: prop => !ignoredProps.includes(prop)
})`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-style: normal;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
  border: none;
  background: transparent;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  appearance: none;
  transition: all 150ms ease-in;

  & > :not(:last-child) {
    margin-right: 8px;
  }

  &:active {
    color: ${th.color('primary.d1')};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  ${({ variant }) => css`
    color: ${th.color(variant === 'light' ? 'black' : 'white')};

    &:focus,
    &:hover {
      background: ${th.color(
        variant === 'light' ? 'grey.l4' : 'whiteAlpha.400'
      )};
    }
  `};

  ${({ inline }) =>
    inline &&
    css`
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      padding: 0 12px;

      &:focus,
      &:hover {
        color: ${th.color('primary.base')};
        background: transparent;
      }
    `};
`

const DropdownHeader = styled.divBox.withConfig({
  shouldForwardProp: prop => !ignoredProps.includes(prop)
})`
  display: flex;
  align-items: center;
  color: black;
  font-size: 1rem;
  font-style: normal;
  min-height: 2.5rem;
  line-height: 1.5rem;
  user-select: none;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  padding: 0.25rem 1rem 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0;
  border-bottom: 1px solid ${th.color('grey.l2')};

  & > :not(:last-child) {
    margin-right: 0.5rem;
  }

  ${({ inline }) =>
    inline &&
    css`
      min-height: 2.25rem;
      border-radius: 0.25rem;
      padding: 0 0.75rem;
      border: none;
    `};
`

const DropdownItemText = styled.spanBox.withConfig({
  shouldForwardProp: prop => !ignoredProps.includes(prop)
})`
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
`

const DropdownDivider = styled.hr.withConfig({
  shouldForwardProp: prop => !ignoredProps.includes(prop)
})`
  width: 100%;
  border-width: 0px 0px 1px;
  border-top-style: initial;
  border-right-style: initial;
  border-left-style: initial;
  border-bottom-style: solid;
  border-color: ${th.color('grey.l2')};
  pointer-events: none;
  user-select: none;
  margin: 8px 0;
`

/**
 * Attaching internal id to default props as
 * We can't rely on any other property including displayName as styles-components overrides them
 */
DropdownItem.defaultProps = { internalId: 'DropdownItem' }
DropdownHeader.defaultProps = { internalId: 'DropdownHeader' }
DropdownItemText.defaultProps = { internalId: 'DropdownItemText' }
DropdownDivider.defaultProps = { internalId: 'DropdownDivider' }

export { DropdownItem, DropdownHeader, DropdownItemText, DropdownDivider }
